import * as yup from "yup";

export const schemaForms = yup.object({
    cluster_id: yup.string(),
    cluster_name: yup.string().required("O campo Nome Cluster é obrigatório"),
    public_host: yup.string().required("O campo Host Público é obrigatório"),
    private_host: yup.string().required("O campo Host Privado é obrigatório"),
    port: yup
        .number()
        .typeError("O campo Porta deve ser um número")
        .required("O campo Porta é obrigatório"),
    username: yup.string().required("O campo Usuário é obrigatório"),
    password: yup.string().required("O campo Senha é obrigatório"),
    ssl_enabled: yup.boolean().required("O campo SSL é obrigatório"),
    ssl_cert: yup.string().when("ssl_enabled", {
        is: true,
        then: (schema) =>
            schema.required(
                "O campo Certificado SSL é obrigatório quando o SSL está habilitado"
            ),
        otherwise: (schema) => schema.notRequired(),
    }),
    customer_database_type_id: yup
        .number()
        .typeError("O campo Tipo de Banco é obrigatório")
        .required("O campo Tipo de Banco é obrigatório"),
    cloud: yup.string().required("O campo cloud é obrigatório"),
});
